import React from 'react';
const FinishAuthContent = () => {
    return (
        <div className="px-10 py-[30px]">
            <span className="block text-[#0E141A] text-[16px] font-medium leading-[22px]">Сервис PriceNinja сейчас в разработке и будет запущен до 31 марта 2024 года.<br /><br />Мы с вами свяжемся.</span>
        </div>
    )
}

export {FinishAuthContent}